import { optionLabel } from "../../configurazione/adapters";
import React, {useState} from 'react';
import stilePulsanti from '../../../interfaccia/stilePulsanti';
//import ImpostaCorriere from './ImpostaCorriere';
//import ImpostaPartenzaDa from './ImpostaPartenzaDa';
import CreaReport from './CreaReport';
import CambiaDatoMassivo from './CambiaDatoMassivo';

function BarraFunzioniOrdini({ 
    righeSelezionate,
    fetchOrdini,
    page,
    setRigheSelezionate,
    setDeseleziona,
    deseleziona,
    datiTendineOrdine,
    tema,
    vista,
    ricerca,
    urlRicerca,
    setAlertSalvataggio,
    columnControl,
    canUpdateLogistica
}) {

    /* const handleChange = async function (evt) {
        const value = evt.target.value;
        setLimiteRighe(value);
    } */
    const {
        buttonClassesWhite,
        buttonClassesWhiteNoBorder
    } = stilePulsanti

    if (!ricerca) {
        ricerca = {
            "sped.Stato_Ordine =" : null
        }
    }

    function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
      }

    function formatDate(date = new Date()) {
        return [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate()),
        ].join('-');
      }

    const [dataPartenza, setDataPartenza] = useState(formatDate())
    const [partenzaDa, setPartenzaDa] = useState("Villanova Mondovì")

    function handleChangeDataPartenza(evt) {
        setDataPartenza(evt.target.value);
    }
    function handleChangePartenzaDa(evt) {
        setPartenzaDa(evt.target.value);
    }

    const refresh = function() {
        fetchOrdini(1)
    }

    const deselezionaTutto = function() {
        setDeseleziona(!deseleziona);
        setRigheSelezionate([])
    }

    return (
        <div className='formRicercaOrizzontale pa2 flex justify-around items-center'>
        <div className='gruppoInputRicercaOrizzontale'>
        <div className='b'>{righeSelezionate.length} ordini selezionati</div>
        <button className={stilePulsanti.buttonClassesWhite} onClick={deselezionaTutto}>deseleziona tutto</button> 
        </div>
        {canUpdateLogistica && <>
        <div className='flex items-center'>
           {vista !== "articoli" && 
           <div className='gruppoInputRicercaOrizzontale'>
           <div className=''>cambio stato</div>            
           <CambiaDatoMassivo
                updateFieldsAndValues={[{field:"Stato_Ordine",value:"IN ATTESA", operator: "="}]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={buttonClassesWhiteNoBorder+" colAttesa"}
                testo="ATTESA"
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            />
            <CambiaDatoMassivo
                updateFieldsAndValues={[{field:"Stato_Ordine",value:"PREPARAZIONE", operator: "="}]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={buttonClassesWhiteNoBorder+" colPreparazione"}
                testo="PREP"
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            />
            {/* AGGIORNARE DA QUI IN AVANTI CON NUOVO COMPONENTE UNIVERSALE */}
            <CambiaDatoMassivo
                updateFieldsAndValues={[{field:"Stato_Ordine",value:"RICERCA", operator: "="}]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={buttonClassesWhiteNoBorder+" colRicerca"}
                testo="RICERCA"
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            />
            <CambiaDatoMassivo
                updateFieldsAndValues={[{field:"Stato_Ordine",value:"TROVATO", operator: "="}]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={buttonClassesWhiteNoBorder+" colTrovato"}
                testo="TROV"
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            />
            <CambiaDatoMassivo
                updateFieldsAndValues={[
                    {field:"Stato_Ordine",value:"PRONTO EXP", operator: "="},
                    {field:"Data_partenza",value:dataPartenza, operator: "="}
                ]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={buttonClassesWhiteNoBorder+" colTrovato"}
                testo={"PRONTO EXP "+dataPartenza}
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            /> 
            <CambiaDatoMassivo
                updateFieldsAndValues={[{field:"Stato_Ordine",value:"ETICHETTE", operator: "="}]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={buttonClassesWhiteNoBorder+" colEtichette"}
                testo="ETICHETTE"
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            />
            <CambiaDatoMassivo
                updateFieldsAndValues={[{field:"Stato_Ordine",value:"SPEDITO", operator: "="}]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={buttonClassesWhiteNoBorder+" colSpedito"}
                testo="SPEDITO"
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            /> 
            <CambiaDatoMassivo
                updateFieldsAndValues={[
                    {field:"Stato_Ordine",value:"SPEDITO", operator: "="},
                    {field:"Data_partenza",value:dataPartenza, operator: "="}
                ]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={buttonClassesWhiteNoBorder+" colSpedito"}
                testo={"SPEDITO IL "+dataPartenza}
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            /> 
            <div className='gruppoInputRicercaOrizzontale mr2'>
            <label className='mr1 b' for="dataPartenza">Data per cambio: </label>
            <input
                        type="date"
                        name="dataPartenza"
                        onChange={handleChangeDataPartenza}
                        value={dataPartenza}
                        className="input-reset inputOrizzontale"
                    ></input>
            </div>    
            <CambiaDatoMassivo
                updateFieldsAndValues={[
                    {field:"Partenza_da",value:partenzaDa, operator: "="},
                ]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={buttonClassesWhite}
                testo={"PARTE DA "+partenzaDa}
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            />       
            <label className='mr1 b' for="dataPartenza">Magazzino partenza: </label>
            <select
            name="partenzaDa"
            id="partenzaDa"
            onChange={handleChangePartenzaDa}
            value={partenzaDa}
                    className="inputOrizzontale"
            >
                {datiTendineOrdine.partenzaDa.map((mag,i) => <option key={i+1} value={mag}>{optionLabel(datiTendineOrdine.partenzaDa, mag)}</option> )}
            </select>
            </div>
            } 
            {(!ricerca["sped.Stato_Ordine ="] && vista === "articoli") && <div className='b'>filtra per stato PREPARAZIONE per prenotare gli articoli, filtra per stato RICERCA per contrassegnarli come TROVATI</div>}
            {ricerca["sped.Stato_Ordine ="] === "RICERCA" && 
                <div className='flex'>
                <CambiaDatoMassivo
                updateFieldsAndValues={[
                    {field:"Stato_Ordine",value:"TROVATO", operator: "="},
                    {field:"Data_partenza",value:dataPartenza, operator: "="}
                ]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={stilePulsanti.buttonClassesGreen}
                testo={"TROVATO"}
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
                />
                <CambiaDatoMassivo
                updateFieldsAndValues={[
                    {field:"Stato_Ordine",value:"IN ATTESA", operator: "="},
                    {field:"Data_partenza",value:null, operator: "="}
                ]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={stilePulsanti.buttonClassesRed}
                testo={"ATTESA"}
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
                />
                </div>
            }
            {ricerca["sped.Stato_Ordine ="] === "PREPARAZIONE" && 
            <div className='flex items-center'>
            <CambiaDatoMassivo
                updateFieldsAndValues={[
                    {field:"Stato_Ordine",value:"RICERCA", operator: "="},
                    {field:"Partenza_da",value:partenzaDa, operator: "="}
                ]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={buttonClassesWhite}
                testo={"QUESTE LE CERCHIAMO A "+partenzaDa}
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
                />
            <label className='mr1 b' for="dataPartenza">Cambia: </label>
            <select
            name="partenzaDa"
            id="partenzaDa"
            onChange={handleChangePartenzaDa}
            value={partenzaDa}
                    className="inputOrizzontale"
            >
                {datiTendineOrdine.partenzaDa.map((mag,i) => <option key={i+1} value={mag}>{optionLabel(datiTendineOrdine.partenzaDa, mag)}</option> )}
            </select>
            </div>
            }
            
            </div>      
            {vista !== "articoli" && <div className='flex'>
            <div className='ml4 mr3 b' for="">Sposta su corriere:</div>
            {/* <ImpostaCorriere 
                ordini={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                corriere="BRT"
                classe={buttonClassesWhite+" colBRT"}
                testo={"BRT"}
                refresh={refresh}
                vista={vista}
            />    */}   
            <CambiaDatoMassivo
                updateFieldsAndValues={[
                    {field:"Corriere",value:"BRT", operator: "="}
                ]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={stilePulsanti.buttonClassesWhite+" colBRT"}
                testo={"BRT"}
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            />   
            {/* <ImpostaCorriere 
                ordini={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                corriere="DPD"
                classe={buttonClassesWhite+" colBRT"}
                testo={"DPD"}
                refresh={refresh}
                vista={vista}
            />   */}  
            <CambiaDatoMassivo
                updateFieldsAndValues={[
                    {field:"Corriere",value:"DPD", operator: "="}
                ]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={stilePulsanti.buttonClassesWhite+" colBRT"}
                testo={"DPD"}
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            />        
            {/* <ImpostaCorriere 
                ordini={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                corriere="DHL"
                classe={buttonClassesWhite+" colDHL"}
                testo={"DHL"}
                refresh={refresh}
                vista={vista}
            />    */}     
            <CambiaDatoMassivo
                updateFieldsAndValues={[
                    {field:"Corriere",value:"DHL", operator: "="}
                ]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={stilePulsanti.buttonClassesWhite+" colDHL"}
                testo={"DHL"}
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            /> 
            {/* <ImpostaCorriere 
                ordini={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                corriere="UPS"
                classe={buttonClassesWhite+" colUPS"}
                testo={"UPS"}
                refresh={refresh}
                vista={vista}
            />   */}   
            <CambiaDatoMassivo
                updateFieldsAndValues={[
                    {field:"Corriere",value:"UPS", operator: "="}
                ]}
                wheresAndValues={[]}
                ordiniSelezionati={righeSelezionate}
                deselezionaTutto={deselezionaTutto}
                classe={stilePulsanti.buttonClassesWhite+" colUPS"}
                testo={"UPS"}
                refresh={refresh}
                vista={vista}
                setAlertSalvataggio={setAlertSalvataggio}
            /> 
            </div>}
        </>}
            <div className='flex items-center ml2'>

            
            {stilePulsanti.tastoStampaAspetto}
            {/* <div className='ml4 mr3 b' for="">Stampa</div> */}
            <CreaReport 
                ordini={righeSelezionate}
                classe={buttonClassesWhite+" ml2"}
                testo={"stampa"/* stilePulsanti.tastoStampaAspetto */}
                datiTendineOrdine={datiTendineOrdine}
                tema={tema}
                vista={vista}
            />
            </div>
        {columnControl}
        </div>

    )
}


export default BarraFunzioniOrdini;
